import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import * as _ from 'lodash';

@Pipe({
    name: 'filterByRole'
})
export class FilterPipe implements PipeTransform {
    transform(value: any, searchText: any, arg1: any[]): any {
        if (!searchText) {
            return value;
        }
        return value.filter((data) => this.matchValue(data, searchText, arg1));
    }

    matchValue(data, value, arg1) {
        return arg1.map((keyParams) => {
            return new RegExp(value, 'gi').test(data[keyParams.itemName]);
        }).some(result => result);
    }
}

@Pipe({
    name: 'filterByRole1'
})
export class FilterPipe1 implements PipeTransform {
    transform(value: any, searchText: any, arg1: any[]): any {
        if (!searchText) {
            return value;
        }
        return value.filter((data) => this.matchValue(data, searchText, arg1));
    }

    matchValue(data, value, arg1) {
        return arg1.map((keyParams) => {
            return new RegExp(value, 'gi').test(data[keyParams.filter]);
        }).some(result => result);
    }
}

@Pipe({
    name: 'orderByName'
})
export class OrderByPipe implements PipeTransform {

    transform(array: Array<{}>, args: string[]): Array<string> | Array<{}> {

        array = array || [];

        if (typeof args === 'undefined' || args.length !== 2) {
            return array;
        }

        const [key, direction] = args;

        if (direction !== 'ASC' && direction !== 'DESC') {
            return array;
        }

        return _.orderBy(array, (item: any) => item[key], direction.toLowerCase());
    }
}

@Pipe({
    name: 'searchFile'
})
export class SearchFile implements PipeTransform {

    transform(value: any[], search: string): any {
        if (!value || !search) {
            return value;
        }

        return value.filter(value => value.path.toLowerCase().indexOf(search.toLowerCase()) !== -1);
    }
}

@Pipe({
    name: 'searchByName'
})
export class FilterByName implements PipeTransform {

    transform(value: any[], search: string): any {
        if (!value || !search) {
            return value;
        }

        return value.filter(value => value.name.toLowerCase().indexOf(search) !== -1);
    }
}

@Pipe({
    name: 'searchByObject'
})
export class SearchByObject implements PipeTransform {

    transform(value: any[], key: string, search: string): any {
        if (!value || !search) {
            return value;
        }
        return value.filter(val => val[key].toLowerCase().indexOf(search) !== -1);
    }
}


@Pipe({
    name: 'viewMore'
})
export class ViewMore implements PipeTransform {

    transform(value: any[], limit: number) {
        if (!value || !limit) {
            return value;
        }
        if (limit < value.length) {
            return value.slice(0, limit);
        }
        return value;
    }
}


@Pipe({
    name: 'filterByQuery'
})
export class FilterByQuery implements PipeTransform {

    transform(value: any[], search: any): any {
        if (!value || !search) {
            return value;
        }
        return value.filter(value =>
            (value.custom_id.toLowerCase().indexOf(search.toLowerCase()) !== -1)
            || (value.username.toLowerCase().indexOf(search.toLowerCase()) !== -1));
    }
}

@Pipe({
    name: 'objectfilter'
})
export class FilterByObject implements PipeTransform {
    transform(items: any, filter: any, isAnd: boolean): any {
        if (filter && Array.isArray(items)) {
            let filterKeys = Object.keys(filter);
            if (isAnd) {
                return items.filter(item =>
                    filterKeys.reduce((memo, keyName) =>
                        (memo && new RegExp(filter[keyName], 'gi').test(item[keyName])) || filter[keyName] === '', true));
            } else {
                return items.filter(item => {
                    return filterKeys.some((keyName) => {
                        return new RegExp(filter[keyName], 'gi').test(item[keyName]) || filter[keyName] === '';
                    });
                });
            }
        } else {
            return items;
        }
    }
}

@Pipe({name: 'safeUrl'})
export class YouTubeURLFilter implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {
    }

    transform(videoId) {
        const url = 'https://www.youtube.com/embed/' + videoId;
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

@Pipe({name: 'sanitizeUrl'})
export class urlYouTubeFilter implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {
    }

    transform(videoId) {
        const url = 'https://www.youtube.com/embed/' + videoId;
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

@Pipe({name: 'dataAnalyticseUrl'})
export class urlDataAnalyticsFilter implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {
    }

    transform(id) {
        const url = 'https://www.dashbo.ai/data-analytics-chart/' + id;
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}


@Pipe({
    name: 'filterExecutors'
})
export class FilterExecutorsPipe implements PipeTransform {
    transform(executors: any[], searchText: string): any[] {
        if (!executors) {
            return [];
        }
        if (!searchText) {
            return executors;
        }
        if (searchText && searchText !== '') {
            searchText = searchText.toLowerCase();

            return executors.filter(executor =>
                (executor &&  executor.executor_name && executor.executor_name.toLowerCase().includes(searchText) ||
                    executor &&  executor.executor_description && executor.executor_description.toLowerCase().includes(searchText) ||
                    executor &&  executor.executor_method_type && executor.executor_method_type.toLowerCase().includes(searchText))
            );
        } else {
            return [];
        }

    }
}

// @Pipe({name: 'filterByString', pure: false})
// export class filterByName implements PipeTransform {
//     transform(listOfNames: string[], nameToFilter: string): string[] {
//         if (!listOfNames) return null;
//         if (!nameToFilter) return listOfNames;
//         return listOfNames.filter( n => n.indexOf(nameToFilter) >= 0);
//     }
// }
// @Pipe({name: 'filterByName', pure: false})
// export class filterNames implements PipeTransform {
//     transform(listOfNames: any[], nameToFilter: object): string[] {
//         if (!listOfNames) return null;
//         if (!nameToFilter) return listOfNames;
//         return listOfNames.filter( listOfNames => listOfNames.executor_name.indexOf(nameToFilter['executor_name']) >= 0);
//     }
// }
// @Pipe({name: 'filterByName1', pure: false})
// export class filterNames1 implements PipeTransform {
//     transform(listOfNames: any[], nameToFilter: object): string[] {
//         if (!listOfNames) return null;
//         if (!nameToFilter) return listOfNames;
//         return listOfNames.filter( listOfNames => listOfNames.categoryName.indexOf(nameToFilter['executor_name']) >= 0);
//     }
// }
